<template>
  <v-expansion-panels focusable multiple>
    <v-expansion-panel v-for="compra in venda.compras" :key="compra.id">
      <v-expansion-panel-header>
        <px-venda-conjunta-vendas-header :venda="compra" @update="onUpdate"/>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <px-venda-conjunta-vendas-produtos :venda="compra" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import VendaConjuntaVendasHeader from './VendaConjuntaVendasHeader.vue';
import VendaConjuntaVendasProdutos from './VendaConjuntaVendasProdutos.vue';

export default {
  props: {
    venda: Object,
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
  },
  components: {
    pxVendaConjuntaVendasHeader: VendaConjuntaVendasHeader,
    pxVendaConjuntaVendasProdutos: VendaConjuntaVendasProdutos,
  },
};
</script>
